import { useEffect, useState } from 'react';

/**
 * The editable copy behind a profile editor. Re-seeds each time the modal opens
 * so a cancelled edit doesn't linger, and only closes once the save reports back
 * that it landed.
 */
export function useModalDraft<T>(
  isOpen: boolean,
  defaultValues: T | null,
  onSave: (values: T) => Promise<boolean>,
  onClose: () => void,
) {
  const [values, setValues] = useState<T | null>(defaultValues);

  useEffect(() => {
    if (isOpen) setValues(defaultValues);
  }, [isOpen, defaultValues]);

  const handleSave = async () => {
    if (values && (await onSave(values))) onClose();
  };

  return { values, setValues, handleSave };
}
